import {
  Button,
  Col,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Typography,
} from "antd";
import { gioiTinhOptions } from "assets/constants/select-catagory-options";
import { HeaderPrintForm } from "components/common";
import {
  birthday2Age,
  convertCurrencyToWords,
  convertIosStringToDateObjectDayjs,
  formatDateToString,
  formatToCurrencyType,
  getDateStringLocale,
  getDateStringLocaleDetail,
} from "helper/common";
import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import dayjs from "dayjs";
import { FORMAT_TIME } from "types/enums";
import moment from "moment";
import { payService } from "api";
import residentialNurseService from "api/residentialNurse";
import Notification from "components/common/notification/notification";

const columns: any = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: "4%",
    fixed: "left",
    align: "center",
  },
  {
    title: "Nội dung",
    dataIndex: "noiDung",
    key: "noiDung",
    align: "left",
    // width: "60%",
  },
  {
    title: "Số tiền phụ thu",
    dataIndex: "soTienPhuThu",
    key: "soTienPhuThu",
    align: "right",
    width: "120px",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
];

const { Text } = Typography;

const ModalPrintPPT = (props) => {
  const {
    isShowModal,
    handleOk,
    handleCancel,
    listId,
    dataPPT,
    value,
    callApi = true,
    dataPatient,
  } = props;
  const printRef = useRef<any>();
  const [data, setData] = useState([]);
  const [thongTinIn, setThongTinIn] = useState<any>(null);
  const [listTTT, setListTTT] = useState([]);
  const [tongTien, setTongTien] = useState(0);

  const onPrint = async () => {
    window.print();
  };
  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const renderTime = (time) => {
    if (time) {
      const timestamp = time;
      const date = new Date(timestamp);

      // Get day, month, and year
      const day = ("0" + date.getDate()).slice(-2);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } else return "";
  };
  useEffect(() => {
    getListLoaiTTT();
    if (callApi) {
      getData();
    } else {
      setThongTinIn({
        ...dataPatient,
        ngaySinh: renderTime(dataPatient?.ngaySinh),
        // thoiGianKham: dataPatient?.ngayVaoVien,
        hoTen: dataPatient?.hoVaTen,
      });
      const newData = dataPPT.map((item) => ({
        noiDung: item.content,
        soTienPhuThu: item.thanhTienChuaMienGiam,
      }));
      let tong = 0;
      dataPPT.forEach((element) => {
        tong += element.thanhTienChuaMienGiam;
      });
      setTongTien(tong);
      // console.log('data in tạm ứng ppt', newData);
      setData(newData);
    }
  }, [isShowModal]);

  const getData = async () => {
    try {
      let response = await payService.getDataPrintPPT(listId).then((res) => {
        setThongTinIn(res.data);
        // dataPPT[0].noiDung = value.label;

        const newData = dataPPT.map((item) => ({
          ...item,
          noiDung: value,
        }));
        // console.log('data in tạm ứng ppt', newData);
        setData(newData);
      });
    } catch (err) {}
  };

  const getListLoaiTTT = async () => {
    try {
      const res = await residentialNurseService.getListLoaiTTT();

      const options = res.data.map((item) => {
        return { value: item.id, label: item.tenTheoThuongMai } || [];
      });
      setListTTT(options);
    } catch (error) {
      Notification(
        "error",
        "Đã xảy ra lỗi khi lấy danh sách loại thủy tinh thể nhân tạo"
      );
    }
  };

  columns.map((item) => {
    // if (item.key == "noiDung") {
    //   item.render = (value, record) => (
    //     <Select
    //       style={{ width: "500px" }}
    //       options={listTTT}
    //       defaultValue={listTTT[0]}
    //       value={value}
    //       bordered={false}
    //       onChange={(e, option) => {
    //         setData((prevDataTable) => {
    //           return prevDataTable.map((prevItem) =>
    //             prevItem.id === record.id
    //               ? {
    //                   ...prevItem,
    //                   noiDung: option.label,
    //                 }
    //               : prevItem
    //           );
    //         });
    //       }}
    //     ></Select>
    //   )
    // }
    if (item.key == "soTienPhuThu") {
      if (callApi) {
        item.render = (value, record) => (
          <div>
            {formatToCurrencyType(record.soTienTamUng - record.soTienBaoCao)}
          </div>
        );
      } else
        item.render = (value, record) => (
          <div>{formatToCurrencyType(value)}</div>
        );
    }
  });

  const calculateAge = (birthDate) => {
    let currentDate: any = new Date();
    let birthDateParts: any = birthDate.split("/"); // Chia chuỗi thành mảng [ngày, tháng, năm]

    // Chuyển đổi ngày sinh thành một đối tượng Date
    let birthDateObject: any = new Date(
      birthDateParts[2],
      birthDateParts[1] - 1,
      birthDateParts[0]
    ); // Lưu ý: tháng trong đối tượng Date từ 0 đến 11

    let ageInMilliseconds = currentDate - birthDateObject;
    let ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25); // Sử dụng 365.25 để xem xét năm nhuận
    let ageInMonths = ageInYears * 12;

    if (ageInYears < 1) {
      return Math.floor(ageInMonths) + " tháng";
    } else {
      return Math.floor(ageInYears) + " tuổi";
    }
  };

  return (
    <Row className="exam-reg-bill-ppt" style={{ fontSize: "10px" }}>
      <Modal
        wrapClassName="modal-custom-print"
        centered
        open={isShowModal}
        onCancel={handleCancel}
        closable={false}
        footer={null}
        width={1000}
      >
        <div className="print-thanh-toan-don">
          <div ref={printRef}>
            <HeaderPrintForm />
            <Row
              style={{
                paddingLeft: "68px",
                paddingRight: "68px",
              }}
            >
              <Row justify={"center"}>
                <Typography.Title
                  style={{
                    fontWeight: "700",
                    fontSize: "30px",
                  }}
                >
                  PHIẾU PHỤ THU
                </Typography.Title>
              </Row>
              <Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Typography.Text style={{ fontWeight: "800" }}>
                      {thongTinIn?.hoTen?.toUpperCase()}
                    </Typography.Text>
                    {thongTinIn?.gioiTinh
                      ? ` - ${
                          gioiTinhOptions.find(
                            (it) => it.value === thongTinIn?.gioiTinh
                          )?.label
                        }`
                      : ""}{" "}
                    -{" "}
                    {thongTinIn?.ngaySinh
                      ? calculateAge(thongTinIn?.ngaySinh)
                      : ""}{" "}
                    -
                    {thongTinIn?.ngaySinh
                      ? `(SN: ${thongTinIn?.ngaySinh})`
                      : "(SN: )"}
                    {/* {thongTinIn?.soDienThoai ? ` - ${thongTinIn.soDienThoai}` : ""} */}
                  </Col>
                  <Col>
                    <Space size={30}>
                      <Typography.Text>
                        Thời gian khám: &nbsp;
                        <Typography.Text>
                          {thongTinIn?.thoiGianKham
                            ? dayjs(thongTinIn?.ngayKham).format(
                                FORMAT_TIME.dayFull
                              )
                            : "" || renderTime(thongTinIn?.ngayNhapVien)}
                        </Typography.Text>
                      </Typography.Text>
                      <Typography.Text>
                        Mã bệnh nhân: &nbsp;
                        <Typography.Text strong>
                          {thongTinIn?.maBenhNhan}
                        </Typography.Text>
                      </Typography.Text>
                    </Space>
                  </Col>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Typography.Text>
                      Địa chỉ: &nbsp;
                      <Typography.Text>{thongTinIn?.diaChi}</Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col>
                    <Typography.Text
                      style={{
                        paddingRight: thongTinIn?.soDienThoai ? "" : "90px",
                      }}
                    >
                      SĐT: &nbsp;
                      <Typography.Text>
                        {thongTinIn?.soDienThoai
                          ? ` ${thongTinIn.soDienThoai}`
                          : ""}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                </Row>
              </Row>
              <Row style={{ marginTop: "10px" }}>
                <Table
                  bordered
                  columns={columns}
                  dataSource={data}
                  style={{ width: "100%" }}
                  pagination={false}
                />
              </Row>
              <Row style={{ marginTop: "10px" }}>
                <Space>
                  <Text strong>Tổng cộng :</Text>
                  <Typography.Text strong>
                    {formatToCurrencyType(
                      thongTinIn?.tongPhieuPhuThu || tongTien
                    )}
                  </Typography.Text>
                </Space>
              </Row>
              <Row>
                <Space>
                  <Text strong>Tổng tiền bằng chữ :</Text>
                  <Typography.Text strong>
                    {capitalizeFirstLetter(thongTinIn?.tongPhieuPhuThuChu) ||
                      capitalizeFirstLetter(
                        convertCurrencyToWords(Math.round(tongTien) ?? "")
                      )}
                  </Typography.Text>
                </Space>
              </Row>
              <Row style={{ marginTop: "0px" }}>
                <Row justify={"end"}>
                  <Typography.Text
                    className="date-sign"
                    style={{ marginRight: "15px" }}
                  >
                    {getDateStringLocale(thongTinIn?.ngayUng)}
                  </Typography.Text>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>Người nộp tiền</Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text type="secondary">
                          (Ký và ghi rõ họ tên)
                        </Typography.Text>
                      </Row>
                    </Row>
                  </Col>
                  <Col>
                    <Space direction="vertical" size={64}>
                      <Row>
                        <Row justify={"center"}>
                          <Typography.Text strong>Tên thu ngân</Typography.Text>
                        </Row>
                        <Row justify={"center"}>
                          <Typography.Text type="secondary">
                            (Ký và ghi rõ họ tên)
                          </Typography.Text>
                        </Row>
                      </Row>
                      {/* <Row justify={'center'}>
                      <Typography.Text strong>{thongTinIn?.tenThuNgan ? thongTinIn?.tenThuNgan : localStorage.getItem("fullName")}</Typography.Text>
                    </Row> */}
                    </Space>
                  </Col>
                </Row>
                <Row></Row>
              </Row>
              <Row justify={"center"} style={{ marginTop: "80px" }}>
                <Typography.Text style={{ fontSize: "12px" }} strong>
                  Quý khách có nhu cầu hóa đơn VAT xin vui lòng báo lễ tân /
                  CSKH 0866.224.883 ngay trong ngày phát sinh dịch vụ, Bệnh viện
                  không hỗ trợ xuất hóa đơn VAT nếu nhận thông tin sau thời điểm
                  này. Xin cảm ơn
                </Typography.Text>
              </Row>
            </Row>
            {/* </Watermark> */}
          </div>
        </div>
        <Row justify={"end"} style={{ padding: "12px", gap: "4px" }}>
          <Space direction="horizontal">
            <Button danger type="primary" onClick={handleCancel}>
              HỦY
            </Button>
            <ReactToPrint
              trigger={() => {
                return (
                  <Button type="primary" onClick={onPrint}>
                    IN
                  </Button>
                );
              }}
              content={() => printRef.current}
              onAfterPrint={handleCancel}
              bodyClass="print-thanh-toan-don"
            />
          </Space>
        </Row>
      </Modal>
    </Row>
  );
};

export default ModalPrintPPT;
